import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import ToolsGeneralContent from './components/ToolsGeneralContent';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

interface ToolsGeneralProps extends NavigationProps {}

const ToolsGeneral: FC<ToolsGeneralProps> = ({ lg }) => {
  return (
    // TODO: When this screen is enabled, pass refetchTools prop to ToolsGeneralContent
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }}>
        <ToolsGeneralContent />
      </View>
    </MachinesProvider>
  );
};

export { ToolsGeneral };
